//noinspection JSUnusedGlobalSymbols
export const environment = {
  production: true,
  canEdit: true,
  canSave: true,
  api: 'https://test.api.process-manager.dk/api/',
  base: 'https://test.api.process-manager.dk/',
  nonconformity: 'https://test.nc.process-manager.dk/'
};
